// SPDX-FileCopyrightText: 2025 Dusan Mijatovic (Netherlands eScience Center)
// SPDX-FileCopyrightText: 2025 Netherlands eScience Center
//
// SPDX-License-Identifier: Apache-2.0

export const softwareOrderOptions = [
  {key: 'contributor_cnt', label: 'Contributors', direction:'desc.nullslast'},
  {key: 'mention_cnt', label: 'Mentions', direction:'desc.nullslast'},
  {key: 'brand_name', label: 'Name', direction: 'asc.nullslast'},
]

export const highlightOrderOptions = [
  {key: 'position', label: 'Featured latest', direction: 'asc.nullslast'},
  {key: 'contributor_cnt', label: 'Contributors', direction:'desc.nullslast'},
  {key: 'mention_cnt', label: 'Mentions', direction:'desc.nullslast'},
  {key: 'brand_name', label: 'Name', direction: 'asc.nullslast'},
]
